import { render, staticRenderFns } from "./DropdownElementTaco.vue?vue&type=template&id=895e67c6&scoped=true&"
import script from "./DropdownElementTaco.vue?vue&type=script&lang=js&"
export * from "./DropdownElementTaco.vue?vue&type=script&lang=js&"
import style0 from "./DropdownElementTaco.vue?vue&type=style&index=0&id=895e67c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895e67c6",
  null
  
)

export default component.exports